import script from "./AgreementRecordsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementRecordsView.vue?vue&type=script&setup=true&lang=js"

import "./AgreementRecordsView.vue?vue&type=style&index=0&id=bf3d49c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf3d49c6"]])

export default __exports__